import type {TicketingQuestion} from '@Components/event-wizard/event-wizard-ticketing/event-wizard-ticketing.types';
import type {TicketingQuestionEditorMode} from '@Components/event-wizard/event-wizard-ticketing/components/ticketing-question-editor/ticketing-question-editor.types';

export interface TicketingQuestionsEditorState {
  mode: TicketingQuestionEditorMode;
  /** Array index of the question being edited; in add mode this is the append position. */
  index: number;
  draft: TicketingQuestion;
  /** The committed question captured at edit open, restored to Redux on cancel; null in add mode. */
  original: TicketingQuestion | null;
}

export interface TicketingDefaultRow {
  labelKey: string;
  icon: string;
}

export const TICKETING_QUESTIONS_DRAG_HANDLE = 'ticketing-question-drag-handle';
